let vacancyOverviewFilters = document.querySelector('.block_vacancy_overview.has_filters');
let filters = document.querySelector('.filter-holder');
let filtersOpen = document.querySelector('.js-open-filters');
let filtersReset = document.querySelector('.js-reset-filters');
let filtersClose = document.querySelectorAll('.js-close-filters');
let filtersGroupTitle = document.getElementsByClassName('js-filter');
let i;

for (i = 0; i < filtersGroupTitle.length; i++) {
    filtersGroupTitle[i].addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('open');
        var panel = this.nextElementSibling;
        if (panel.style.display === '' || panel.style.display === 'none') {
            panel.style.display = 'block';
        } else {
            panel.style.display = 'none';
        }
    });
}

if (vacancyOverviewFilters) {
    filtersOpen.addEventListener('click', openFilters);
    filtersReset.addEventListener('click', function () {
        mSearch2.reset()
    });

    for (let i = 0; i < filtersClose.length; i++) {
        filtersClose[i].addEventListener('click', closeFilters);
    }

    function openFilters() {
        filters.classList.add('open');
        document.body.classList.add('filters-open');
    }

    function closeFilters() {
        filters.classList.remove('open');
        document.body.classList.remove('filters-open');
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.body.clientWidth >= 768) {
        let vacancyGrid = document.querySelector('.block_vacancy_overview .vacancy-grid');
        let columnLeft = vacancyGrid.querySelectorAll('.vacancy-grid .item:nth-child(odd)');
        let columnRight = vacancyGrid.querySelectorAll('.vacancy-grid .item:nth-child(even)');
        let leftHeight = []
        let rightHeight = []

        //Get all heights in left column and push in leftHeight array
        function getLeft(columnLeft) {
            leftHeight = []
            columnLeft.forEach(function (element) {
                leftHeight.push(element.offsetHeight + 37);
            });
        }

        //Get all heights in right column and push in rightHeight array
        function getRight(columnRight) {
            rightHeight = []
            columnRight.forEach(function (element) {
                rightHeight.push(element.offsetHeight + 37);
            });
        }

        //Calculate total height of elements
        function calculateElementsHeight(arr) {
            return arr.reduce((total, current) => {
                return total + current;
            }, 0);
        }

        //Get the highest value and set height to container div
        function setContainerHeight(column1, column2, container) {
            let height = Math.max(column1, column2);
            container.style.height = height + 'px';
        }

        //Set highest value to container div on load
        getLeft(columnLeft);
        getRight(columnRight);
        setContainerHeight(calculateElementsHeight(leftHeight), calculateElementsHeight(rightHeight), vacancyGrid);

        let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        let observer = new MutationObserver(resultsChanged);
        observer.observe(vacancyGrid, {
            childList: true
        });

        function resultsChanged() {
            //Set highest value to container div on change
            let columnLeftChanged = vacancyGrid.querySelectorAll('.vacancy-grid .item:nth-child(odd)');
            let columnRightChanged = vacancyGrid.querySelectorAll('.vacancy-grid .item:nth-child(even)');
            getLeft(columnLeftChanged);
            getRight(columnRightChanged);
            setContainerHeight(calculateElementsHeight(leftHeight), calculateElementsHeight(rightHeight), vacancyGrid);
        }

        window.addEventListener('resize', function () {
            let columnLeftResize = vacancyGrid.querySelectorAll('.vacancy-grid .item:nth-child(odd)');
            let columnRightResize = vacancyGrid.querySelectorAll('.vacancy-grid .item:nth-child(even)');
            getLeft(columnLeftResize);
            getRight(columnRightResize);
            setContainerHeight(calculateElementsHeight(leftHeight), calculateElementsHeight(rightHeight), vacancyGrid);
        });
    }
});

document.querySelectorAll('.banner .anchor').forEach(trigger => {
    trigger.onclick = function (e) {
        e.preventDefault();
        let hash = this.getAttribute('href');
        let target = document.querySelector(hash);
        let offsetPosition = target.offsetTop;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    };
});
